<template>
  <div id="app">
    <router-view />
    <loading />
    <msg />
  </div>
</template>

<script>
import Loading from '@/components/common/Loading';
import Msg from '@/components/common/Msg';

export default {
  name: 'App',
  components: { Loading, Msg },
  computed: {
    cachedViews() {
      return this.$store.state.tagsView.cachedViews;
    }
  }
};
</script>
